import Typography from '@mui/material/Typography';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import theme from '../../theme';

const Loading = ({ isLoading, content, variant, invisibleBg }) => {

  return (
    <>
      {
        variant !== 'inside'
        ? (
          <Backdrop
            open={isLoading}
            sx={{
              flexDirection: 'column',
              color: '#fff',
              zIndex: 1500
            }}
          >
            <CircularProgress color="inherit" />
            { content && <Typography mt={2}>{ content }</Typography> }
          </Backdrop>
        ) : (
          <Backdrop
            open={isLoading}
            invisible={!!invisibleBg}
            sx={{
              position: 'absolute',
              zIndex: 500,
              color: theme.palette.grey.dark,
              borderRadius: '4px',
            }}
          >
            <CircularProgress
              sx={{
                color: !!invisibleBg ? theme.palette.grey.w500 : '#fff',
              }}
            />
          </Backdrop>
        )
      }
    </>
  );
};

export default Loading;